/**
 * Used to initialize client-side socket.io connections
 */
import Vue from 'vue';
import moduleIndices from '@/modules/index';
import { connect, io } from 'socket.io-client';
import config from '@/common/config';
export default {
  socket: null,
  interval: null,
  initializeSocketIo({ rootState, commit, dispatch, jwtToken }) {
    if (process.env.VUE_APP_ENABLE_SOCKETIO === 'true') {
      const customer = config.tenant || process.env.VUE_APP_CUSTOMER;
      // const socketIoURI = config.webAppBaseUrl.replace('https:', 'ws:').replace('http:', 'ws:');

      try {
        let socket = io(`/${customer}`, {
          auth: { token: jwtToken },
          reconnection: true,
          reconnectionDelay: 500,
          reconnectionAttempts: 10,
          transports: ['polling'],
        });
        this.socket = socket;

        const connect = () => {
          setTimeout(() => {
            try {
              socket.connect();
            } catch (err) {
              console.warn('socket.connect() failed. Try to establish connection', err);
              socket = io(`/${customer}`, {
                auth: { token: jwtToken },
                reconnection: true,
                reconnectionDelay: 500,
                reconnectionAttempts: 10,
              });
              this.socket = socket;
              connect();
            }
          }, 5000);
        };
        socket.on('connect', () => {
          console.log('socket connected', socket.id);
          joinRoom();
        });

        socket.on('disconnect', (reason) => {
          console.log('socket disconnect', reason, socket.id);
          if (reason === 'io server disconnect') {
            // the disconnection was initiated by the server, you need to reconnect manually
          }
          connect();
        });

        socket.on('connect_error', (err) => {
          console.log('socket connection error', err);
          connect();
        });

        socket.on('user disconnected', (socketId) => {
          console.log(`User ${socketId} disconnected`); //TODO: do we really need to be notified if any user disconnects?
        });

        socket.on('user:connected', ({ tenant, username, userId }) => {
          console.log('User has connected: ', tenant, username, userId);
        });

        const joinRoom = () => {
          let { userId, tenant } = rootState.configs.user;
          const userRoom = `${tenant}/${userId}`;
          console.log('try to join-room with room', userRoom);
          socket.emit('join-room', { room: userRoom }, (response) => {
            console.log('JOINED socket connection room', userRoom, response);
            //commit(`${MODULE_ID}/initConnection`, response.status === 'ok', { root: true });
          });
        };
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (!socket.connected) {
            console.log('socket is not connected. Try to re-connect');
            connect();
          }
        }, 10000);

        // TODO: Remove this if vbz worksheet is removed
        rootState.configs.modules.forEach((module) => {
          let moduleIndex = moduleIndices.getModuleIndexFromModuleType(module.type);
          if (!moduleIndex) {
            console.warn(`moduleIndex of type ${module.type} not found`);
          }
          if (moduleIndex.initModuleSockets) {
            // console.log(`initModuleSockets on module ${moduleIndex.moduleId}`);
            moduleIndex.initModuleSockets({ rootState, commit, dispatch, socket });
          }
        });

        // Debug only
        // socket.onAny((event, ...args) => {
        //   console.log('socket onAny', event, args);
        // });
        // Make socket available from vue components as this.$socket or in non-vue scripts by importing Vue (import Vue from 'vue') and then use it as Vue.$socket

        Vue.prototype.$socket = socket; // used to make accessible in vue components
      } catch (err) {
        console.error('Exception when initializing socketIo', err);
      }
    }
  },
};
